import React from 'react';
import LWTypography from 'components/legacy/LWTypography';

const ErrorContent = () => (
	<LWTypography color="error">
		Something unexpected happened. Please try again or contact a helpful human.
	</LWTypography>
);

export default ErrorContent;
